// Builds the Leaflet tile URL template from the REACT_APP_MAPBOX_TILE env
// value (map plan E1 follow-up, 2026-07-07). DigitalOcean's env editor now
// rejects values containing "{z}"-style braces ('Unexpected "}"'), so the env
// var stores a BRACE-FREE URL and the code inserts the tile placeholders:
//
//   env:  https://api.mapbox.com/styles/v1/USER/STYLE/tiles/256?access_token=pk...
//   out:  https://api.mapbox.com/styles/v1/USER/STYLE/tiles/256/{z}/{x}/{y}@2x?access_token=pk...
//
// Backward compatible: a value that already contains "{z}" (the old format,
// still fine locally) passes through untouched.
//
// Dark mode (dark = true) swaps whatever style the env URL names for Mapbox's
// own dark style, keeping the access token and tile size; light mode returns
// the URL exactly as before.
const DARK_STYLE = 'mapbox/dark-v11';

const withPlaceholders = (value: string): string => {
  if (!value || value.includes('{z}')) {
    return value;
  }
  if (value.includes('?')) {
    return value.replace('?', '/{z}/{x}/{y}@2x?');
  }
  return value + '/{z}/{x}/{y}@2x';
};

export const buildTileUrl = (raw?: string, dark = false): string => {
  const url = withPlaceholders(raw || '');
  return dark
    ? url.replace(/\/styles\/v1\/[^/]+\/[^/]+\/tiles\//, '/styles/v1/' + DARK_STYLE + '/tiles/')
    : url;
};
